// @flow
import React, { Component } from "react";
import SortState from "../../models/SortState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SORT_DIRECTION } from "../../models/Sort";
import JobLibraryTitleRequestListStore from "../../stores/mobx/JobLibraryTitleRequestListStore";
import { TITLE_REQUEST_SORT_FIELD } from "../../constants/jobLibraryTitleRequest";
import classNames from "classnames";

function isSortAsc(sortState: ?SortState, field: string) {
  if (!sortState) return false;
  if (sortState.field !== field) return false;
  return !sortState.direction || sortState.direction === SORT_DIRECTION.ASC;
}

function isSortDesc(sortState: ?SortState, field: string) {
  if (!sortState) return false;
  if (sortState.field !== field) return false;
  if (!sortState.direction) return false;

  return sortState.direction === SORT_DIRECTION.DESC;
}

type Props = {
  store: JobLibraryTitleRequestListStore,
  actions?: any,
  children: any,
};

export default class LibraryTitleRequestTable extends Component<Props> {
  handleSortByStatus: () => void;
  handleSortByTitle: () => void;
  handleSortByCreated: () => void;

  constructor(props: Props) {
    super(props);

    this.handleSortByStatus = this.handleSortByStatus.bind(this);
    this.handleSortByTitle = this.handleSortByTitle.bind(this);
    this.handleSortByCreated = this.handleSortByCreated.bind(this);
  }

  handleSortByStatus() {
    const { store } = this.props;

    store.onSortByField(TITLE_REQUEST_SORT_FIELD.STATUS, true);
  }

  handleSortByTitle() {
    const { store } = this.props;

    store.onSortByField(TITLE_REQUEST_SORT_FIELD.TITLE);
  }

  handleSortByCreated() {
    const { store } = this.props;

    store.onSortByField(TITLE_REQUEST_SORT_FIELD.CREATED, true);
  }

  render() {
    const props = this.props;
    const { store } = props;
    if (!store) return <code>Store required to render table</code>;
    const sortState = store.sortState;

    const sortedByStatus =
      sortState && sortState.field === TITLE_REQUEST_SORT_FIELD.STATUS;
    const sortedByTitle = sortState && sortState.field === TITLE_REQUEST_SORT_FIELD.TITLE;
    const sortedByCreated =
      sortState && sortState.field === TITLE_REQUEST_SORT_FIELD.CREATED;

    const statusSortIcon = !sortedByStatus
      ? "sort"
      : (isSortAsc(sortState, TITLE_REQUEST_SORT_FIELD.STATUS) && "sort-up") ||
        (isSortDesc(sortState, TITLE_REQUEST_SORT_FIELD.STATUS) && "sort-down");
    const statusSortIconClasses = classNames("sort-icon", {
      "sort-none": !sortedByStatus,
    });

    const titleSortIcon = !sortedByTitle
      ? "sort"
      : (isSortAsc(sortState, TITLE_REQUEST_SORT_FIELD.TITLE) && "sort-up") ||
        (isSortDesc(sortState, TITLE_REQUEST_SORT_FIELD.TITLE) && "sort-down");
    const titleSortIconClasses = classNames("sort-icon", { "sort-none": !sortedByTitle });

    const createdSortIcon = !sortedByCreated
      ? "sort"
      : (isSortAsc(sortState, TITLE_REQUEST_SORT_FIELD.CREATED) && "sort-up") ||
        (isSortDesc(sortState, TITLE_REQUEST_SORT_FIELD.CREATED) && "sort-down");
    const createdSortIconClasses = classNames("sort-icon", {
      "sort-none": !sortedByCreated,
    });

    return (
      <div className="cjl-flex-table">
        <div className="cjl-flex-table header">
          <div className="column auto cjl-caret-col" />
          <div
            className="column auto click-enabled cjl-title-request-status-col"
            onClick={this.handleSortByStatus}
          >
            <span>
              Status{" "}
              <FontAwesomeIcon icon={statusSortIcon} className={statusSortIconClasses} />
            </span>
          </div>
          <div className="column click-enabled" onClick={this.handleSortByTitle}>
            <span>
              Title{" "}
              <FontAwesomeIcon icon={titleSortIcon} className={titleSortIconClasses} />
            </span>
          </div>
          <div className="column auto cjl-countries-count-col">
            <span>Countries</span>
          </div>
          <div
            className="column auto click-enabled cjl-date-col"
            onClick={this.handleSortByCreated}
          >
            <span>
              Submitted{" "}
              <FontAwesomeIcon
                icon={createdSortIcon}
                className={createdSortIconClasses}
              />
            </span>
          </div>
          {props.actions && (
            <div className="column auto cjl-job-title-actions-col">Actions</div>
          )}
        </div>
        {props.children}
      </div>
    );
  }
}
